<div *ngIf="loading">Cargando archivo...</div>
<div *ngIf="error">{{ error }}</div>

<div *ngIf="attachment && !loading && !error">
  <h6>Título: {{ attachment.fileName }}</h6>
  <div class="mb-3">
    <button class="btn btn-outline-primary btn-sm" (click)="openInNewTab()">
      Abrir en nueva pestaña
    </button>
  </div>

  <ng-container *ngIf="isPDF; else imageTemplate">
    <iframe 
      [src]="fileUrl | safe" 
      width="100%" 
      height="600px"
      frameborder="0">
    </iframe>
  </ng-container>

  <ng-template #imageTemplate>
    <img 
      [src]="fileUrl" 
      [alt]="attachment.title || attachment.fileName"
      style="max-width: 100%; max-height: 600px;" />
  </ng-template>
</div>
